<script setup lang="ts">
import { computed, toRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { isNil } from 'lodash';

import CheckTaskOutcomeChip from '@/components/CheckTaskOutcomeChip.vue';
import { relatedObjectToYardArea } from '@/helpers/checkTaskDetailsTitle';
import YardAreaPresenterV2 from '@satellite/components/elements/presenters/YardAreaPresenterV2.vue';
import { getCheckOutcomeChipDisplay } from '@satellite/helpers/yardTaskUtils';

import type { CheckTaskViewData } from '@nova/core';

const props = defineProps<{
  task: CheckTaskViewData;
}>();

const task = toRef(props, 'task');
const { t } = useI18n();

const relatedObject = computed(() => task.value.relatedObject);

const areaId = computed(() => relatedObject.value?.id ?? null);
const areaYard = computed(() => relatedObjectToYardArea(relatedObject.value) ?? null);

const showOutcome = computed(() => !isNil(getCheckOutcomeChipDisplay(task.value)));
</script>

<template>
  <v-card variant="flat" border class="text-center" data-testid="check-task-details-title">
    <v-card-text>
      <div class="check-task-title d-flex align-center justify-center gap-2">
        <v-icon size="small" icon="mdi-map-marker-outline" />
        <yard-area-presenter-v2
          v-if="areaId"
          :area-id="areaId"
          :placeholder-area-data="areaYard"
          :name-props="{ class: 'typography-heading-lg-bold text--color-text-secondary' }"
          size="large" />
        <v-chip v-if="areaId" size="small" variant="tonal">
          {{ t('checkTaskDetails.entityChips.area') }}
        </v-chip>
      </div>

      <template v-if="showOutcome">
        <v-divider class="my-4" />
        <div class="d-flex justify-center">
          <check-task-outcome-chip :task="task" />
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>
